// ChartsPage.js
import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import Chart from 'react-apexcharts';

const ChartsPage = () => {
  const [title, setTitle] = React.useState('');
  const [isMobile, setIsMobile] = React.useState(false);
  useEffect(() => {
    if (window.innerWidth < 767) {
      setIsMobile(true);
    }
    window.addEventListener('resize', (event) => {
      if (event.target.innerWidth < 767) {

        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }, true);

    // Allow page scroll (index.css sets overflow:hidden + position:fixed on html/body for the map)
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
    document.body.style.height = 'auto';
    document.documentElement.style.overflow = 'auto';
    document.documentElement.style.position = 'static';
    document.documentElement.style.height = 'auto';

    // Set body background to white with multiple approaches for better coverage
    document.body.style.backgroundColor = 'white';
    document.body.style.background = 'white';
    document.body.style.setProperty('background-color', 'white', 'important');
    document.body.style.setProperty('background', 'white', 'important');
    
    // Also set html element background
    document.documentElement.style.backgroundColor = 'white';
    document.documentElement.style.background = 'white';
    
    //get items from local storage
    const newReports = JSON.parse(localStorage.getItem('newReports')) || [];
    const chartOptions = JSON.parse(localStorage.getItem('chartOptions')) || [];
    setTitle(localStorage.getItem('reportTitle'));
    console.log('newReports', newReports, chartOptions);
    if (newReports.length !== 0) {
      //append a div with id 'chart' and index number to the pdfReportElement
      const column1 = document.getElementById('column1');
      const column2 = document.getElementById('column2');
      //clear children from pdfReportElement
      column1.innerHTML = '';
      column2.innerHTML = '';
      for (let i = 0; i < newReports.length; i++) {
        console.log('newReports[i]', newReports[i]);
        const chartElement = document.createElement('div');
        // add padding
        if (isMobile) {
          chartElement.style.padding = '7vw';
        }
        chartElement.id = `chart${i}`;
        if (i % 2 === 0) {
          column1.appendChild(chartElement);
        } else {
          column2.appendChild(chartElement);
        }
      }

    }
    for (let i = 0; i < chartOptions.length; i++) {
      const div = document.getElementById(chartOptions[i].id);
      if (div) {
        const root = createRoot(div);
        root.render(<Chart options={chartOptions[i].options} series={chartOptions[i].series} type="bar" />);
      }
    }
    // remove Items from local storage
    localStorage.removeItem('chartOptions');
    localStorage.removeItem('newReports');
    localStorage.removeItem('reportTitle');
    
    // Cleanup: restore global scroll lock and background when leaving /charts
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.height = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.position = '';
      document.documentElement.style.height = '';
      document.body.style.backgroundColor = '';
      document.body.style.background = '';
      document.body.style.removeProperty('background-color');
      document.body.style.removeProperty('background');
      document.documentElement.style.backgroundColor = '';
      document.documentElement.style.background = '';
    };
  }, [])
  return (
    <div style={{ 
      padding: '20px', 
      backgroundColor: 'white',
      minHeight: '100vh',
      background: 'white'
    }}>
      <h1 style={{ textAlign: 'center' }}>{title}</h1>
      {!isMobile ? <div id="pdfreport" style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        <div id="column1" style={{ flex: "1 1 45%", minWidth: 300, padding: "10px", minHeight: 300 }}></div>
        <div id="column2" style={{ flex: "1 1 45%", minWidth: 300, padding: "10px", minHeight: 300 }}></div>
      </div>
        : <div id="pdfreport" style={{ display: "flex", flexDirection: "column" }}>
          <div id="column1" style={{ padding: '10px' }}></div>
          <div id="column2" style={{ padding: '10px' }}></div>
        </div>}
      {/* <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} style={{ flex: '1 0 50%', padding: '10px' }}>
            <Chart options={chartOptions} series={chartSeries} type="bar" height={320} />
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default ChartsPage;